import { render, staticRenderFns } from "./AreaInteresseList.vue?vue&type=template&id=9baba0ce&scoped=true"
import script from "./AreaInteresseList.vue?vue&type=script&lang=js"
export * from "./AreaInteresseList.vue?vue&type=script&lang=js"
import style0 from "./AreaInteresseList.vue?vue&type=style&index=0&id=9baba0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baba0ce",
  null
  
)

export default component.exports